export default "__VITE_ASSET__CFjWl4dH__"